import { makeStyles } from '@fluentui/react-components';
import { tokens } from '../../../../../../theme/fluent';

export const useDashboardMeetingBadgesStyles = makeStyles({
  badgeWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: tokens.spacingVerticalXXL,
    rowGap: tokens.spacingVerticalS,
    columnGap: tokens.spacingHorizontalS,
  },
});
